<template>
<section id="forgot">
    <NavbarDefault route="/" />
    <div class="container d-flex align-items-center justify-content-center width-880">
        <div class="row d-flex align-items-center justify-content-center">
            <div class="col-12 text-center">
                <h2 :class="`c-${getPrimaryColor}four`">Senha recuperada com sucesso!</h2>
                <p class="c-ndarkfour regular">
                    Faça login na plataforma com a sua nova senha.
                </p>
                <SuccessPassword class="my-5" />
                <br>
                <Button class="btn btn-blue" @click="gotoLogin" :color="getPrimaryColor">
                    Fazer login
                </Button>
                <!-- <router-link to="/">
                </router-link> -->
            </div>
        </div>
    </div>
    <Footer />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import SuccessPassword from '@/components/ilustra/SuccessPassword'
import Footer from '@/components/navigation/footer/Footer'

export default {
    components: {
        NavbarDefault,
        SuccessPassword,
        Footer
    },
    data() {
        return {}
    },
    methods: {
        gotoLogin() {
            window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
    },
    created() {
        this.$store.commit('user/resetState')
        this.$store.commit('companies/resetState')
        this.$store.commit('register/resetState')
    }
}
</script>

<style>
.width-880 {
    max-width: 880px;
}
</style>
